import {css} from "lit";

export const haAppStyles = css`
`;